import { Link } from "react-router-dom";
import { BRAND, buildWhatsAppLink } from "../data/brand";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-charcoal text-ivory">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 pt-20 pb-10">
      <div className="grid md:grid-cols-12 gap-12 md:gap-8">
        <div className="md:col-span-5">
          <img src="images/SK-logo-nobg.png" alt="SK Fragrances" className="h-16 mb-6 object-contain" />
          <p className="font-serif text-2xl leading-snug text-ivory/90 max-w-sm">
            SK Fragrances — crafting authentic incense fragrances in Bangalore since 1980.
          </p>
          <p className="mt-6 text-xs tracking-[0.3em] text-gold">THE ART OF FRAGRANCE, PERFECTED.</p>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs tracking-[0.3em] text-gold mb-5">EXPLORE</h4>
          <ul className="space-y-3 text-sm text-ivory/75">
            <li><Link to="/" className="nav-link hover:text-ivory" data-testid="footer-home">Home</Link></li>
            <li><Link to="/products" className="nav-link hover:text-ivory" data-testid="footer-products">Products</Link></li>
            <li><Link to="/about" className="nav-link hover:text-ivory" data-testid="footer-about">Our Story</Link></li>
            <li><Link to="/contact" className="nav-link hover:text-ivory" data-testid="footer-contact">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs tracking-[0.3em] text-gold mb-5">COLLECTIONS</h4>
          <ul className="space-y-3 text-sm text-ivory/75">
            <li><Link to="/products?category=Economy" className="nav-link hover:text-ivory">Economy</Link></li>
            <li><Link to="/products?category=Premium" className="nav-link hover:text-ivory">Premium</Link></li>
            <li><Link to="/products?category=Assorted" className="nav-link hover:text-ivory">Assorted Pouches</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs tracking-[0.3em] text-gold mb-5">CONTACT</h4>
          <ul className="space-y-3 text-sm text-ivory/75">
            <li>{BRAND.city}, {BRAND.region}</li>
            <li><a href={`tel:${BRAND.phone}`} className="nav-link hover:text-ivory">{BRAND.phone}</a></li>
            <li>
              <a href={buildWhatsAppLink(`Hi ${BRAND.name}, I would like to know more about your incense products.`)} target="_blank" rel="noreferrer" className="nav-link hover:text-ivory" data-testid="footer-whatsapp">
                WhatsApp
              </a>
            </li>
            <li><a href={`mailto:${BRAND.email}`} className="nav-link hover:text-ivory">{BRAND.email}</a></li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-6 border-t border-ivory/15 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-ivory/55 tracking-wide">
        <span>© 1980 SK Fragrances. All Rights Reserved.</span>
        <span className="tracking-[0.25em]">MADE IN BANGALORE, INDIA</span>
      </div>
    </div>
  </footer>
);
